import { render, staticRenderFns } from "./appointmentsDropdownContents.vue?vue&type=template&id=4a3a5df4&scoped=true"
import script from "./appointmentsDropdownContents.vue?vue&type=script&lang=js"
export * from "./appointmentsDropdownContents.vue?vue&type=script&lang=js"
import style0 from "./appointmentsDropdownContents.vue?vue&type=style&index=0&id=4a3a5df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a5df4",
  null
  
)

export default component.exports